var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cd-timeline-content cd-timeline-card--default" },
    [
      _c("div", { staticClass: "cd-timeline-content-text" }, [
        _c(
          "div",
          { staticClass: "container-authorization" },
          [
            _c(
              "CompassAvatarName",
              {
                staticClass: "user-profile",
                attrs: {
                  firstname: _vm.getTargetedStaffFirstname,
                  lastname: _vm.getTargetedStaffLastname,
                  size: "extra-small"
                }
              },
              [
                _c("CompassAvatar", {
                  attrs: {
                    initials: _vm.getTargetedStaffInitials,
                    size: "extra-small",
                    colorType: _vm.getTargetStaffAvatarRandomColor
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-regular" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.eventText) +
                    "\n            "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "date-log typographies-paragraph-small-regular" },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$filters.dateFormatter(
                    _vm.oneLog.timestamp,
                    "NORMAL_DATE_TIME",
                    true
                  )
                ) +
                "\n        "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }